import React from 'react'
import styles from './CitationMetadata.module.scss';

export default function CitationMetadata(props) {
    const { author_citation, metadata } = props;
    return (
        <div className={styles.citation}>
            {author_citation.map((author, index) => (
                <span key={index}>
                    {author.lastname}, {author.name}
                    {index < author_citation.length - 1 ? '; ' : ' / '}
                </span>
            ))}
            {metadata.year}. "{metadata.title}." <em>The Journal of Private Enterprise,</em> {metadata.volume}({metadata.number}): {metadata.pages}
        </div>
    )
}
